import { render, staticRenderFns } from "./result.vue?vue&type=template&id=2ae5d975&scoped=true&"
import script from "./result.js?vue&type=script&lang=js&"
export * from "./result.js?vue&type=script&lang=js&"
import style0 from "./result.vue?vue&type=style&index=0&id=2ae5d975&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae5d975",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ae5d975')) {
      api.createRecord('2ae5d975', component.options)
    } else {
      api.reload('2ae5d975', component.options)
    }
    module.hot.accept("./result.vue?vue&type=template&id=2ae5d975&scoped=true&", function () {
      api.rerender('2ae5d975', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/comment/result/result.vue"
export default component.exports